import {
  ArrowLeftOutlined,
  CaretDownOutlined,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { Input, Select } from 'antd';
import { RoutesV1 } from 'constants/appRoutes';
import { optionsFilter, provinceList } from 'constants/index';
import useDevice from 'hooks/useDevice';
import { defaultIcon } from 'pages/DetailGiftCategory';
import React, { memo, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import './style.css';

const HeaderSearchFilter = ({ handleChangeFilter, search, filter, handleChangeSearch }) => {
  const { isMobile } = useDevice();
  const loyaltyInfoCategory = JSON.parse(localStorage.getItem('typeGift'));

  const infoGiftRef = useRef({
    img: loyaltyInfoCategory.icon || defaultIcon,
    name: loyaltyInfoCategory.title || 'Quà tặng',
  }).current;

  const [isOpenSearch, setIsOpenSearch] = useState(false);

  return (
    <div className='flex flex-wrap justify-between items-center my-2 pb-2 border-b pt-12 px-4 lg:px-0 lg:pt-0 lg:pb-0 lg:border-b-0'>
      <div className='flex grow items-center'>
        <Link to={'/pages/loyalty-store'} className='p-1 mr-1 bg-white rounded-full'>
          <ArrowLeftOutlined
            style={{
              fontSize: '20px',
            }}
          />
        </Link>
        {(isOpenSearch || search) && isMobile ? null : (
          <>
            <img
              src={infoGiftRef.img}
              width={30}
              height={30}
              className='mx-2'
              alt={infoGiftRef.name}
            />
            <p className='text-20px grow text-black font-averta-bold line-clamp-1'>
              {infoGiftRef.name}
            </p>
          </>
        )}

        <Input
          onFocus={() => setIsOpenSearch((prev) => !prev)}
          onBlur={() => {
            setIsOpenSearch((prev) => !prev);
          }}
          onChange={(e) => handleChangeSearch(e.target.value)}
          className={`mx-2.5 bg-d9d9d9 min-w-[46px] overflow-hidden ${
            isOpenSearch || search ? 'w-full rounded-xl py-2' : 'w-[46px] rounded-full'
          } custom_input_filter lg:hidden`}
          // bordered={false}
          placeholder='Tìm kiếm (theo tên quà tặng)'
          prefix={<SearchOutlined style={{ color: '#7b7b7b', fontSize: '20px' }} />}
          allowClear={{
            clearIcon: <PlusOutlined rotate={45} style={{ color: '#7b7b7b', fontSize: '20px' }} />,
          }}
        />
      </div>
      <div className='flex justify-center items-center w-full lg:w-fit'>
        <Input
          style={{ borderRadius: '500px', overflow: 'hidden' }}
          className='hidden lg:flex mx-2.5 bg-d9d9d9 w-[200px] custom_input_filter'
          placeholder='Tìm kiếm...'
          prefix={<SearchOutlined style={{ color: '#7b7b7b', fontSize: '20px' }} />}
          onChange={(e) => handleChangeSearch(e.target.value)}
          allowClear={{
            clearIcon: <PlusOutlined rotate={45} style={{ color: '#7b7b7b', fontSize: '20px' }} />,
          }}
        />
        <div className='flex justify-center grow-1 items-center mt-4 lg:mt-0'>
          <div className='text-14px flex items-center'>
            <span className='whitespace-nowrap text-7B7B7B'>Áp dụng:</span>
            <Select
              value={filter.cityCode}
              style={{ width: 130, color: '#008BD2' }}
              className='custom_select_filter'
              bordered={false}
              onChange={(value) => handleChangeFilter(value, 'cityCode')}
              options={provinceList}
              suffixIcon={<CaretDownOutlined />}
            />
          </div>
          <div className='w-px h-4 mr-2 bg-979797'></div>
          <div className='text-14px flex items-center'>
            <span className='whitespace-nowrap text-7B7B7B'>Sắp xếp:</span>
            <Select
              value={filter.sort}
              style={{ width: 125, color: '#008BD2' }}
              className='custom_select_filter'
              bordered={false}
              onChange={(value) => handleChangeFilter(value, 'sort')}
              options={optionsFilter}
              suffixIcon={<CaretDownOutlined />}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(HeaderSearchFilter);
